<template>
    <div class="container boxShadow">
        <div class="formbox">
            <h5 class="form_title">注册</h5>
            <custom-form :options="options" @carryData="getFormData"></custom-form>
            <div class="form_footer">
                <span @click="$router.push('/login')">验证码登录</span>
                <span @click="$router.push('/forget')">忘记密码</span>
            </div>
        </div>
    </div>
</template>

<script>
    import customForm from '../components/form.vue'
    export default {
        inject: ['ajax'],
        data() {
            return {
                // phone - 手机号  vert - 图形验证码  code - 短信验证码  psw - 密码  repsw - 再次输入密码  notice - 法律生命  btn - 按钮
                options: {
                    phone: { name: '手机号' },
                    vert: { name: '验证码' },
                    code: { name: '动态码' },
                    psw: { name: '密码' },
                    repsw: { name: '再次输入密码' },
                    notice: true,
                    btn: { name: '同意条款并注册' }
                }
            };
        },
        methods: {
            getFormData(data) {
                this.ajax('/api/reg/reg', 'post', this.$qs.stringify(data), res => {
                    this.$alert('注册成功', () => {
                        this.$router.push('/login')
                    })
                })

            }
        },
        components: {
            customForm
        },
    };
</script>

<style scoped>
    .container {
        min-height: 770px;
        background: url(../../public/images/login.jpg) 100% 100% no-repeat;
        position: relative;
    }

    @media only screen and (max-width: 750px){
        .btn{font-size: 1em;}
        .repeat>input{
            width: 1.9rem!important;
        }
        .container{background: #fff;}
        .formbox{width: 100%;position: relative;top: 0;right: 0;transform: translate(0,0)}
        .form_footer{font-size: 0.13rem;}
        
    }
</style>